export enum State {
	INITIAL = 1,
	DOCTYPE,
	TEXT,
	TAG,
	ATTR,
	CDATA,
	SCRIPT,
	STYLE,
}
